import { connect } from 'react-redux';
import type { ConnectedProps } from 'react-redux';

import { submitCigaretteAction as submitCigarette } from 'src/store/analytics/slice';
import { getIsWhitelabel } from 'src/store/view/selectors';
import HeaderSearchForm from './HeaderSearchForm';

const mapStateToProps = (state) => ({
  isWhiteLabel: getIsWhitelabel(state),
});

const mapDispatchToProps = {
  submitCigarette,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
export type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(HeaderSearchForm);
